import { IoArrowBackOutline, IoTrashOutline } from "react-icons/io5";
import { deleteService, updateService } from "../../redux/services";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { ErrorBanner } from "../../components/banner";
import { Section } from "../../components/section";
// Import your beautiful, reusable form!
import { ServicesForm } from "./ServicesForm";
import styled from "styled-components";
import { useEffect } from "react";

export const ServicesEdit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { error } = useSelector((state) => state.services);

  const rowData = location.state;

  useEffect(() => {
    if (!rowData) {
      navigate("/services", { replace: true });
    }
  }, [rowData, navigate]);

  if (!rowData) return null;

  // --- ACTIONS ---

  // Notice how onFormSubmit receives BOTH values and files from ServiceForm
  const onFormSubmit = (values, attachedFiles) => {
    if (window.confirm(`Are you sure you want to update this service?`)) {
      const payload = {
        ...values,
        files: attachedFiles,
      };

      dispatch(updateService({ id: rowData.id, values: payload }))
        .unwrap()
        .then(() => navigate("/services"))
        .catch((err) => console.error("Failed to update service:", err));
    }
  };

  const handleDelete = () => {
    if (
      window.confirm(
        `Are you sure you want to completely delete "${rowData.title}"?`,
      )
    ) {
      dispatch(deleteService(rowData.id))
        .unwrap()
        .then(() => navigate("/services"));
    }
  };

  return (
    <Section>
      {error && <ErrorBanner text={error} />}

      <TopBar>
        <BackButton onClick={() => navigate(-1)}>
          <IoArrowBackOutline /> Back to Directory
        </BackButton>

        <DeleteButton onClick={handleDelete} title="Delete Service">
          <IoTrashOutline size={18} /> Delete Service
        </DeleteButton>
      </TopBar>

      {/* Render the reusable form and pass in the data */}
      <ServicesForm initialValues={rowData} onFormSubmit={onFormSubmit} />
    </Section>
  );
};

// --- STYLED COMPONENTS ---

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;

  @media screen and (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const BackButton = styled.button`
  background: white;
  border: 1px solid #e5e7eb;
  color: #4b5563;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
  &:hover {
    background: #f9fafb;
    color: #111;
  }
`;

const DeleteButton = styled.button`
  background: white;
  border: 1px solid #fccfcf;
  color: #dc3545;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  &:hover {
    background: #fdedec;
    border-color: #dc3545;
  }
`;
